module.exports = __webpack_public_path__ + "img/2_144.7cd1c9cf.png";